export default __webpack_public_path__ + "static/media/rewards_icon_hospitality.c956f6d4.svg";